/**
 * @generated SignedSource<<f4a74928a059d44ccee17674ecea08a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNav_buyPage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespTopNavFilters_itemSearch" | "SbRespRefineTopAppliedFilters_itemSearch" | "SbRespSortItems_itemSearch" | "useMeasurementUnit_itemSearch">;
  readonly " $fragmentType": "BuyRespTopNav_buyPage";
};
export type BuyRespTopNav_buyPage$key = {
  readonly " $data"?: BuyRespTopNav_buyPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespTopNav_buyPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNav_buyPage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyRespTopNavFilters_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopAppliedFilters_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_itemSearch"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_itemSearch",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParam",
          "kind": "LinkedField",
          "name": "appliedFilters",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParamValue",
              "kind": "LinkedField",
              "name": "values",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlLabel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "7bd48dc4051e140ae5b4a4c51d0e19de";

export default node;
